import { ServiceResponse } from "../models/ServiceResponse";
import { http } from "../http/Http";
import { DocumentType } from "../models/DocumentType";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments"

export class DocumentTypeService {

    getDocumentsTypesByFilters = async (filtersArguments: GetByFiltersArguments): Promise<ServiceResponse<DocumentType[]>> => {
        const { data } = await http.post<ServiceResponse<DocumentType[]>>("DocumentType/GetByFilters", filtersArguments);
        return data;
    };

    getDocumentsTypesByFiltersWithPermission = async (filtersArguments: GetByFiltersArguments): Promise<ServiceResponse<DocumentType[]>> => {
        const { data } = await http.post<ServiceResponse<DocumentType[]>>("DocumentType/GetByFiltersWithPermission", filtersArguments);
        return data;
    };
}